import { render, staticRenderFns } from "./SearchChapterItem.vue?vue&type=template&id=584db57c&"
import script from "./SearchChapterItem.vue?vue&type=script&lang=ts&"
export * from "./SearchChapterItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports